import React from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../lib/ContentContext';
import { assetUrl } from '../lib/api';
import { PageHero } from '../components/site/PageHero';
import { SectionHeading } from '../components/site/SectionHeading';

export default function Textile() {
  const { content } = useContent();
  const page = content?.textile_page;
  if (!page) return null;

  return (
    <div>
      <PageHero title={page.hero_title} subtitle={page.hero_subtitle} image={page.hero_image} />
      <section className="py-14 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <SectionHeading>{page.section_title}</SectionHeading>
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {(page.categories || []).map((cat, i) => (
              <Link
                key={i}
                to={`/textile-chemicals/${cat.slug}`}
                data-testid="textile-category-card"
                className="bg-white rounded-2xl shadow-[0_8px_20px_rgba(17,24,39,0.1)] overflow-hidden card-lift block"
              >
                <img src={assetUrl(cat.image)} alt={cat.title} className="w-full h-[200px] object-cover" loading="lazy" />
                <div className="p-6 text-center">
                  <h3 className="text-[#26247B] font-extrabold text-lg">{cat.title}</h3>
                  <p className="mt-2.5 text-black/80 text-sm leading-6">{cat.text}</p>
                  <span className="mt-4 inline-flex text-[#2E8B57] font-bold text-sm hover:underline">View Product List…</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
